/** Rotate an apparent dip into the tunnel frame. Positive I falls along D. */
export function correctApparentDip(beta, apDir, direction, inclination) {
  const D = ((direction % 360) + 360) % 360;
  const dir = ((apDir % 360) + 360) % 360;
  const signedDip = (dir === D ? beta : -beta) - inclination;
  let folded = signedDip;
  if (folded > 90) folded -= 180;
  if (folded < -90) folded += 180;
  return {
    beta: Math.abs(folded),
    apDir: folded >= 0 ? D : (D + 180) % 360,
  };
}
